// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_ops","cls2":"FriendlySutdModal-cls2_wu9 FriendlySutdModal-cls1_ops"};